<!-- elemento ripetuto -->
<div class="form-group row mb-1" *ngIf="isListValid()">
    <ng-container *ngFor="let record of list;;let i=index">                            
        <div class="col-sm-12" *ngIf="record.type=='separator'">
            <hr class="my-1" *ngIf="record.label!=''" />
            <h5 class="text-left text-primary mb-1" *ngIf="record.label!=''">{{record.label}}</h5>
        </div>
        <div *ngIf="record.type!='separator'"
            [class.col-sm-2]="layout=='horizontal' || record.type!='table'"
            [class.col-sm-12]="layout=='vertical' || record.type=='table'" >
            <label *ngIf="record.type!='hidden'" title="{{record.id_customfield}}">{{record.label}}</label>
        </div>
        <div  *ngIf="record.type!='separator'" class="align-middle mb-1" 
            [class.col-sm-4]="layout=='horizontal' || record.type!='table'"
            [class.col-sm-12]="layout=='vertical' || record.type=='table'" >
            <app-field [field]="record" [noLabel]="true"></app-field>
        </div>
    </ng-container>
</div>

<button type="button" class="btn btn-default btn-xs float-right" (click)="openImport()"><i class="fas fa-file-import mr-2"></i>Importa campi da file CSV</button>